import parse from "html-react-parser";
import Typography from "@mui/material/Typography/Typography";
import { Element } from "../../../Interface/scheduler/form";

const Heading = ({ element }: { element: Element }) => {
  if (element) {
    return (
      <div
        className={element?.type}
        key={element?.type}
        data-testid="heading-root"
      >
        <Typography
          variant="h6"
          data-testid="heading-content"
          fontWeight={element?.disableboldfont ? 400 : 600}
        >
          {parse(element?.content || "")}
        </Typography>
      </div>
    );
  }

  return null;
};

export default Heading;
